<template>
  <div>
    <v-layout row class="mt-3">
      <v-flex xs10 sm5 md3>
        <v-select
          :items="column_items"
          item-value="value"
          v-model="sort_column"
          @change="sortBy()"
          label="Sort by"
          color="black"
          clearable
          hide-details
        ></v-select>
      </v-flex>
      <v-flex xs2 sm4 md3>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'asc'"
          :disabled="asc_desc == 'desc' || sort_column == 'no_default'"
          @click="selectAscDesc('desc')"
        >
          <v-icon small>arrow_downward</v-icon>
        </v-btn>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'desc'"
          :disabled="asc_desc == 'asc' || sort_column == 'no_default'"
          @click="selectAscDesc('asc')"
        >
          <v-icon small>arrow_upward</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="reward_report_list"
      class="elevation-1 mt-4"
      style="background-color: white; padding: 10px; border-radius: 10px"
    >
      <template
        slot="headerCell"
        slot-scope="props"
        style="background-color: black"
        >{{ props.header.text }}</template
      >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.no }}</td>
        <td>{{ props.item.campaign_name }}</td>

        <td class="text-xs-center">
          {{ props.item.campaign_service_type }}
        </td>
        <!-- <td class="text-xs-right">
          {{
            props.item.reward_unit == 1
              ? parseFloat(props.item.discount)
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : props.item.discount
          }}
        </td> -->
        <td class="text-xs-center">
          {{
            props.item.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }}
        </td>
        <td class="text-xs-center" v-if="props.item.used">
          <span style="color: green">{{ props.item.used.split("/")[0] }}</span>
          /
          <span style="color: red">{{ props.item.used.split("/")[1] }}</span>
        </td>
        <td v-else></td>
        <td class="text-xs-center">
          {{
            props.item.total_value_price
              ? parseFloat(props.item.total_value_price)
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : "0.00"
          }}
        </td>
        <td class="text-xs-center">
          {{
            props.item.total_paid_price
              ? parseFloat(props.item.total_paid_price)
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : "0.00"
          }}
        </td>
      </template>
      <template slot="footer" style="border: none">
        <td></td>
        <td class="text-xs-left">
          <strong>Total</strong>
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td class="text-xs-center" style="font-weight: bold">
          {{
            reward_report_summary.total_value_price
              ? parseFloat(reward_report_summary.total_value_price)
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : "0.00"
          }}
        </td>
        <td class="text-xs-center" style="font-weight: bold">
          {{
            reward_report_summary.total_paid_price
              ? parseFloat(reward_report_summary.total_paid_price)
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : "0.00"
          }}
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false,
          value: "name",
        },
        { text: "Name", align: "center", value: "reward", sortable: false },
        { text: "Category", align: "center", value: "reward", sortable: false },
        // {
        //   text: "Discount",
        //   value: "discount",
        //   sortable: false,
        //   align: "center",
        // },
        { text: "Amount", value: "amount", sortable: false, align: "center" },
        {
          text: "Use / Cancel",
          value: "use",
          sortable: false,
          align: "center",
        },
        {
          text: "Value price (THB)",
          value: "value_price",
          sortable: false,
          align: "center",
        },
        {
          text: "Paid price (THB)",
          value: "paid_price",
          sortable: false,
          align: "center",
        },
      ],
      column_items: [
        {
          text: "Paid price (THB)",
          value: "total_paid_price",
          sortable: false,
          align: "center",
        },
      ],
      asc_desc: "asc",
      sort_column: "no_default",
      isSort: false,
    };
  },
  watch: {
    reward_report_list: {
      handler: function () {
        if (this.isSort == false) {
          this.asc_desc = "asc";
          this.sort_column = "no_default";
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      reward_report_list: (state) => state.report.reward_report_list,
      reward_report_summary: (state) => state.report.reward_report_summary,
    }),
  },
  methods: {
    async sortBy() {
      if (this.sort_column == undefined) {
        this.sort_column = "no_default";
        this.asc_desc = "asc";
      }

      this.isSort = true;
      const send_json_data = {
        data: this.reward_report_list,
        field: this.sort_column,
        asc_desc: this.asc_desc,
      };

      await this.$store.dispatch("sortData", send_json_data);
      await this.$store.commit("report/getExportReportForm");
      this.$store.commit("report/getExportSummaryForm");
      this.isSort = false;
    },
    selectAscDesc(value) {
      this.asc_desc = value;
      this.sortBy();
    },
  },
};
</script>
<style scoped>
.sort-btn {
  cursor: pointer;
  height: 30px;
  width: 30px;
  background-color: #fafafa;
  border: 1px solid #b8b8b8;
  border-radius: 10px;
  color: #757575;
  margin-top: 10px;
  margin-left: 20px;
}
/* .main-title {
  font-size: 22px;
  font-weight: bold;
}
.text-table {
  font-weight: bold;
  line-height: 30px;
}
.title-store {
  font-size: 19px;
  font-weight: bold;
} */
</style>

